module.exports = __webpack_public_path__ + "img/icon4.8b3cef26.svg";